import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';

export function useBetBuilderLegSetting(leagueId: Ref<number>) {
    const { betBuilderMinLegSettings, betBuilderMinLegCount } = storeToRefs(useFeatureToggleStore());
    const minLegCount = computed(() => betBuilderMinLegSettings.value.find(setting => setting.leagueId === leagueId.value)?.minBetBuilderLegs ?? betBuilderMinLegCount.value);

    return {
        minLegCount,
    };
}
